import { PaletteType } from "@material-ui/core";
import { SearchTermsType } from "../types/SearchTermsType";
import { UserSearchRowType } from "../types/UserSearchRowType";
import { UserDetailsType } from '../types/UserDetailsType';
import { DetailsValuesType } from '../types/DetailsValuesType';

//define empty array
export const initUserSummary : UserSearchRowType[] = [];
export const initUserSearchResults : UserSearchRowType[] = [];
export const initUserDetails : UserDetailsType = {
  emp_no: "",
  location: "",
  first_name: "",
  last_name: "",
  job_title: "",
  status: "",
  seniority_no: "",
  rt_month: "",
  exp_date: "",
  show_details: false
};
export const initSelectedUserDetails: UserDetailsType = {
  emp_no: "",
  location: "",
  first_name: "",
  last_name: "",
  job_title: "",
  status: "",
  seniority_no: "",
  rt_month: "",
  exp_date: "",
  show_details: false
}
export const initSavedUserDetails : DetailsValuesType = {
  emp_no: "",
  rt_month: "",
  exp_date: "",
  details_saved: false
};
export const initSearchTerms : SearchTermsType = {
  emp_no: "",
  first_name: "",
  last_name: "",
  rt_month: "",
  include_terminated: false,
  include_on_leave: false,
  showResults: false
}

export const initialApplicationState = {
  state: {
    progressBar: "",
    theme: 'light' as PaletteType,
    isDark: 'hide-element',
    isLight:'show-element',
    error: 0,
    searchTerms: initSearchTerms,
    userSearchResults: initUserSearchResults,
    selectedUserDetails: initSelectedUserDetails
  }
  //dispatch: null
};

export const initState = {
  progressBar: "",
  theme: 'light' as PaletteType,
  isDark: 'hide-element',
  isLight:'show-element',
  error: 0,
  searchTerms: initSearchTerms,
  userSearchResults: initUserSearchResults,
  selectedUserDetails: initSelectedUserDetails
};
